export enum ProductTypeEnum {
  PAT = "pat",
  OAT = "oat",
  PAYMENT_LINK = "payment-link",
  DELIVERY = "delivery",
  DINE_IN = "dine-in",
  PICKUP = "pickup",
}
